// src/Services/Support.ts
import { toast } from "react-toastify";
import { Logout } from "../Components/Auth/isAuthenticated";
import { api } from "./Api";
import { IErroRest, IRest } from "./Interfaces";

export type SupportCategory =
  | "plans"
  | "banners"
  | "notifications"
  | "establishments"
  | "account"
  | "others";

export const postSupportMessage = async (data: {
  category: SupportCategory;
  subject: string;
  message: string;
}) => {
  try {
    return toast.promise(
      new Promise((resolve, reject) => {
        api
          .post(`/pt_BR/establishment/support`, data, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
            responseType: "json",
          })
          .then((response: IRest) => resolve(response))
          .catch((error) => reject(error));
      }),
      {
        success: "Mensagem enviada com sucesso.",
        error: {
          render(ToastContentProps) {
            const data = ToastContentProps.data as unknown as IErroRest;
            return data.response?.data?.message ?? "Não foi possível enviar a mensagem. Por favor, tente novamente.";
          },
        },
      }
    );
  } catch (erro) {
    Logout();
    return false;
  }
};
